function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.0607 0.0548915C19.3139 -0.0540958 19.6079 0.00221157 19.8028 0.197147C19.9978 0.392148 20.0541 0.686136 19.9451 0.939372L11.9142 19.593C11.8073 19.8413 11.5632 20 11.2961 20C11.2794 20 11.2625 19.9994 11.2456 19.9981C10.9591 19.9767 10.7179 19.7757 10.6449 19.4979L8.5352 11.4648L0.502149 9.35512C0.224307 9.28215 0.0233593 9.04084 0.00188881 8.7544C-0.019549 8.468 0.14313 8.1994 0.406953 8.0858L19.0607 0.0548915ZM9.73758 10.7427L11.4506 17.2655L18.0399 1.96006L2.73463 8.54947L9.25745 10.2626C9.49239 10.3243 9.67588 10.5078 9.73758 10.7427Z",
  fill: "white"
});

var SvgCurrentLocation = function SvgCurrentLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCurrentLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/current-location.53497afb.svg";
export { ForwardRef as ReactComponent };